import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Callout, Typography } from 'seagull';
import { getCumulativeWarning } from '~/components/BillModal/components/BillServiceTableItem/BillServiceTableItem.utils';
import { useLocaleKeys } from '~/i18n';
import { serviceCostModel } from '~/models';
import { costDisplayTextsPath } from '~/models/service-cost/selectors';
import { utils } from '~/utils';
import { getVariantClass, getVariantSkin } from './Callouts.utils';
export default function CumulativeWarningCallout(props) {
    const { service, issueDate, manualServiceBilling, testId, relationshipEffectiveDate, variant } = props;
    const { t: billClientModalTexts } = useLocaleKeys('components.billClientModal');
    const { t: costDisplayTexts } = useLocaleKeys(costDisplayTextsPath);
    const cumulativeWarning = getCumulativeWarning({
        service,
        issueDate,
        manualServiceBilling,
        relationshipEffectiveDate
    });
    function getQuantityText(q) {
        return costDisplayTexts.countWithUnit({
            count: utils.formatNumberWithCommas(q),
            unit: serviceCostModel.pluralizedUnitName(service.cost, q.toNumber(), costDisplayTexts)
        });
    }
    return cumulativeWarning ? /*#__PURE__*/ _jsx(Callout, {
        style: {
            flex: '1'
        },
        classes: {
            wrapper: getVariantClass(variant)
        },
        skin: getVariantSkin(variant),
        intent: cumulativeWarning.isWarning ? 'warning' : 'info',
        testId: "".concat(testId, "-warning"),
        withBorder: variant !== 'row',
        children: serviceCostModel.isVariablePrice(service.cost) ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                cumulativeWarning.billedQuantity.gt(0) && /*#__PURE__*/ _jsx(Typography, {
                    testId: "".concat(testId, "-billed-quantity"),
                    "data-quantity": cumulativeWarning.billedQuantity,
                    children: billClientModalTexts.billedForQuantity({
                        quantity: getQuantityText(cumulativeWarning.billedQuantity)
                    })
                }),
                cumulativeWarning.scheduledQuantity.gt(0) && /*#__PURE__*/ _jsx(Typography, {
                    testId: "".concat(testId, "-scheduled-quantity"),
                    "data-quantity": cumulativeWarning.scheduledQuantity,
                    children: billClientModalTexts.scheduledForQuantity({
                        quantity: getQuantityText(cumulativeWarning.scheduledQuantity)
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: billClientModalTexts.clientApprovalRequired()
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                cumulativeWarning.billedQuantity.gt(0) && /*#__PURE__*/ _jsx(Typography, {
                    testId: "".concat(testId, "-billed-fixed"),
                    children: billClientModalTexts.alreadyBilledForPeriod()
                }),
                cumulativeWarning.scheduledQuantity.gt(0) && /*#__PURE__*/ _jsx(Typography, {
                    testId: "".concat(testId, "-scheduled-fixed"),
                    children: billClientModalTexts.scheduledForPeriod()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: billClientModalTexts.additionalBillRequiresApproval()
                })
            ]
        })
    }) : null;
}
